import { useNavigate } from 'react-router-dom';
import './AboutUsPage.scss';

const ABOUT_US_PARAGRAPHS = [
  'Effiez was founded in 2013 with a simple mission: make life easier for tradies.',
  'From day one, our team has been passionate about supporting the hardworking people who build, maintain, and keep Australia running. We believe tradies should spend less time dealing with paperwork, compliance, rostering, payroll, and administration, and more time focusing on the work that matters.',
  'For over a decade, we\'ve been dedicated to building technology that genuinely makes a difference. Every feature we create is designed with one goal in mind - helping trade businesses become more efficient, productive, and profitable.',
  'At Effiez, we understand that tradies need more than just software. They need support they can rely on.',
  'While many trade management, HR, and finance platforms have moved to automated support systems and offshore help desks, Effiez remains committed to providing real support from real local people. When you need help, you\'ll speak to someone who understands your business and is ready to assist.',
  'This is a commitment that will never change.',
  'We also believe that technology should work for tradies, not the other way around. Software should be simple, practical, and designed around the realities of running a trade business. That\'s why we continuously work alongside tradies, listening to their challenges and building solutions that solve real problems.',
  'Our vision is to become the most trusted partner for trade businesses by combining powerful technology with genuine human support.',
  'Because when tradies succeed, Australia succeeds.',
];

export default function AboutUsPage() {
  const navigate = useNavigate();

  return (
    <div className="about-us-page">
      <div className="about-us-glow about-us-glow-left" />
      <div className="about-us-glow about-us-glow-right" />

      <main className="about-us-shell">
        <div className="about-us-top-actions">
          <button type="button" className="about-us-top-button about-us-top-button-secondary" onClick={() => navigate('/home')}>
            Home
          </button>
          <button type="button" className="about-us-top-button" onClick={() => navigate('/start?auth=signIn')}>
            Sign In
          </button>
        </div>

        <section className="about-us-hero">
          <span className="about-us-kicker">About Us</span>
          <h1>About Effiez</h1>
          <p>
            Built for tradies who need practical software and reliable local support.
          </p>
        </section>

        <section className="about-us-content">
          {ABOUT_US_PARAGRAPHS.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
        </section>

        <footer className="about-us-footer">
          
          <button type="button" className="about-us-footer-link" onClick={() => navigate('/contact-us')}>
            Contact Us
          </button>
        </footer>
      </main>
    </div>
  );
}